import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import PropTypes from 'prop-types';

// Import your images
import SwimScoreSignup1 from '../../../assets/imgs/swimscoreSiginUp1.png';
import SwimScoreSignin from '../../../assets/imgs/swimscoreSignin.png';
import ForgotPass from '../../../assets/imgs/swimscoreForgotPass.png';
import verifyOtp from '../../../assets/imgs/swimscoreVerifyOtp.png';
import resetPass from '../../../assets/imgs/swimscoreResetPassword.png';
const imageMap = {
  signup: [SwimScoreSignup1],
  signin: [SwimScoreSignin],
  ForgotPass: [ForgotPass],
  verifyOtp: [verifyOtp],
  resetPass: [resetPass],
};

function Slider({ type }) {
  const images = imageMap[type] || [];

  if (images.length === 0) return null;

  return (
    <Swiper
      modules={[Pagination, Autoplay, Navigation]}
      spaceBetween={30}
      slidesPerView={1}
      loop={true}
      autoplay={{
        delay: 4000,
        disableOnInteraction: false,
      }}
      speed={800}
      navigation={true}
      pagination={{ clickable: true }}
      className="login-cont-inner"
    >
      {images.map((image, index) => (
        <SwiperSlide key={index}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <img src={image} alt={`${type} Slider`} style={{ width: '60%', height: 'auto', borderRadius: '8px' }} />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

Slider.propTypes = {
  type: PropTypes.oneOf(['signup', 'signin', 'ForgotPass', 'verifyOtp', 'resetPass']).isRequired,
};

export default Slider;
